import api, { handleResponse, handleError } from './api';

/**
 * Ticket tiers — the Eventbrite-style "Early Bird / GA / Regular" options a host
 * puts on an event. The buyer SEES these and selects one at checkout (replacing
 * the old "know the promo code exists and type it in" friction).
 *
 *   TicketTier {
 *     id, eventId, name, priceCents,
 *     capacity (nullable), salesEndAt (nullable ISO),
 *     sortOrder, isActive,
 *     soldCount, remainingCount (nullable), isAvailable, unavailableReason
 *   }
 */
const ticketTierService = {
  /** Public list (also delivered inline on the event payload as `event.tiers`). */
  async listForEvent(eventId) {
    try {
      const response = await api.get(`/events/${eventId}/ticket-tiers`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** Create a tier. body: { name, priceCents, capacity?, salesEndAt?, sortOrder?, isActive? } */
  async create(eventId, body) {
    try {
      const response = await api.post(`/events/${eventId}/ticket-tiers`, body);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** Update a tier (full replace of the editable fields). */
  async update(tierId, body) {
    try {
      const response = await api.put(`/ticket-tiers/${tierId}`, body);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async remove(tierId) {
    try {
      const response = await api.delete(`/ticket-tiers/${tierId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default ticketTierService;
